var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanceMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 58.9s-1 1.5 0 3.1h2.9v-1.1s.5 1.1 4.9 1.1c1.5 0 1.7-1.5.1-1.6c-1.6-.1-1.4-1.2-2.9-3.1l-5 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 58.9s-1 1.5 0 3.1h2.9v-1.1s.5 1.1 4.9 1.1c1.5 0 1.7-1.5.1-1.6c-1.6-.1-1.4-1.2-2.9-3.1l-5 1.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 48.2c-.5-2.5-4.3-4.2-6.7-9.1c0 0-4.1-1.2-10-1.2c0 0-2.6 1.3-1.2 7.3c.9 3.6-1 9.7-3.8 14.2c0 0 4.2 1.6 8.6 0c0 0-1.3-3.1.9-9.1c.7-1.9-1-3.9.7-8.1c0 0 .8 1.8 6.9 7.3c0 0-1.2 5.6.2 10c0 0 .9.4 4.2.4c3.1 0 4.6-.4 4.6-.4s-2.8-3-4.4-11.3",
    fill: "#c28fef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 38.8c-2.1-1-3.4-1.1-4.2-.8c-.3.3-.9 1-1.2 2.3c1.8 1 4.6.8 4.6.8c.8-1.5.8-2.3.8-2.3",
    fill: "#9450e0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c28fef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9 21.5s7.2-2.2 10.3-8.1c0 0 .5 2.3 4.2 4.5c0 0-5.4 4.1-9.2 5.8c0 0-.2 7.4 2.7 14.9c0 0-.3.9-7.1.9c0 0 3.5-6.3-.9-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 21.9s-3.4-2-5-.7c-8.9 7-9.4 8.7-8.4 14.2c0 0 1.8-1.3 5 .2c0 0-1.4-5.5 5-8.4c0 0 .2 4.2-2.1 11.2c0 0 1.4 1.9 5.5 1.9c0 0 4.3-9.1 0-18.4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 12.4s3.9 2.1 3.9 5.4h-2.2s-.2-1.8-1.2-2.5s-.5-2.9-.5-2.9",
    fill: "#9450e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 12.4s-1.7 1.4-2.8 2.7c0 0 .2 1.2 1.1 2.2l2.5-1.3l-1.9 2.3s.7 1.1 2.1 1.6c0 0 1.8-1 2.9-2.1c0 0-3.2-1.8-3.9-5.4",
    fill: "#ffc7ce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 12.6s1.9-1.6 1.4-2.1s-.9-.6-1.4 0l-1.3 1.3c-.7-.6-1 0-1.2.2c-.3.3-.6 1.6-.6 1.6c.5 1.3 1.4 2.5 2.7 3.3c1-.6 2.4-1.6 2.4-2c0-1-2-2.3-2-2.3",
    fill: "#ffdd67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 13.2s.9-.2 1.3.2l-.2.1s-.3-.2-1.1-.3",
    fill: "#eba352"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 36.5s1.6 1.1 5.7.2c0-.1-2.1-1.8-5.7-.2",
    fill: "#9450e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 35.4s-1.1 2.2.7 4.6c.5.6 1.8 1.2 3.3.5c1.4-.6.2-1.1-.4-2.3c.3-.4.7-.7.5-1.1c-.3-.6-1.2-1-1.2-1s.6-.9-2.9-.7",
    fill: "#ffdd67"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 37.2c0-.1-.1-.1-.1-.2c.1.3-.3.8-.5.6c-.4-.4-.9-.8-.9-.8c.6.7 1 1.5 1 1.5c.3-.4.7-.7.5-1.1",
    fill: "#eba352"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33.1s.5 2 .4 3.4c0 0 2.3-.9 5.7.2c0 0-.6-2 .1-3.5c0 0-.4-.9-2.1-1.1l-.7 2.8l-.7-2.8c.1 0-1.5-.5-2.7 1",
    fill: "#ffc7ce"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#eba352"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6 15.6c-.3.3-.9.8-1.7-.1c-.9-.9-.3-1.5.1-2c.2-.2.4-.4.4-.9c0-.4-.9-.8-.5-.5c0 0 .6.3-.2 1.4c-.3.5-.7 1-.3 1.7c.5.7 1.1 1.5 2.1.9c.9-.7.6-1 .1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 21.2h-4.3l3.5 5.6z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 22.1c-.5-.6-1.7-.3-1.7-.3l1.4-1.9c-1.1.8-2.9 1-2.9 1c-1 2-.6 5.8-.6 5.8s-.8-3.9-3.5-5.8c0 0-1.4-.2-3.3.2l2.6 1.3l-2 .8s1.3.2 2.9 1.1c0 0 1.6 6.4-.4 14.4l5.5.3s2.9-5.6-.2-15c1.1-1.2 2.2-1.9 2.2-1.9",
    fill: "#ffc7ce"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8 39.5s5.7-2.1 7.1-.9c0 0-.1.9-7.1.9",
    fill: "#9450e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1 27.2s1.3 4.7-.8 10.5c0 0 2.9-5.2.8-10.5",
    fill: "#c28fef"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 7.9c-7.9 0-6.9-2-6.9 7.9c0 4.7 4.2 6.1 8.6 6c4.4-.1 6.9-1.1 6.9-5.8c0-7.8-2.1-8.1-8.6-8.1",
    fill: "#ffdd67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.3c-.1.7-.1 2-3 1.6c0 0 .4-4.8-1.8-7.5s-2.6-5.1-.9-7c0 0-2-4.4 7.1-5.6c4.6-.6 8.7 1.1 12.9-.8c0 0 3.8 7.5-3.4 8.4c-7.2.9-7.2-1.6-11.4-1c0 0 .5 4.2 1.7 7.1c0 0 .2.8-.8 1.3c0 0-.9-3.9-2.3-4.8c-1.4-.9-1.4 1.3-.7 2.5s1.2 1 1.2 1s1.7 2.5 1.4 4.8",
    fill: "#ffb300"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#937237"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.9,
    cy: 13.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 13.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 17.8c-1.5 1.2-3.2 1.2-4.6 0c-.2-.1-.3.1-.2.3c.5.8 1.4 1.6 2.5 1.6c1.2 0 2.1-.7 2.5-1.6c.2-.2 0-.4-.2-.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanceMusic);
export default __webpack_public_path__ + "static/media/dance_music.d10bdfdbf5e4ff84c259a8193c5fb8d7.svg";
export { ForwardRef as ReactComponent };